/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpvisibility_Subtitle2Inputs */

const en_coinvestments_insights_lpvisibility_subtitle2 = /** @type {(inputs: Coinvestments_Insights_Lpvisibility_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle what this Organisation sees on their Insights page`)
};

/**
* | output |
* | --- |
* | "Toggle what this Organisation sees on their Insights page" |
*
* @param {Coinvestments_Insights_Lpvisibility_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpvisibility_subtitle2 = /** @type {((inputs?: Coinvestments_Insights_Lpvisibility_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpvisibility_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpvisibility_subtitle2(inputs)
});
export { coinvestments_insights_lpvisibility_subtitle2 as "coInvestments_insights_lpVisibility_subtitle" }